import { render, staticRenderFns } from "./ProductsDataDeviceV3.vue?vue&type=template&id=1ac90b7b&"
import script from "./ProductsDataDeviceV3.vue?vue&type=script&lang=js&"
export * from "./ProductsDataDeviceV3.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDataDeviceV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac90b7b')) {
      api.createRecord('1ac90b7b', component.options)
    } else {
      api.reload('1ac90b7b', component.options)
    }
    module.hot.accept("./ProductsDataDeviceV3.vue?vue&type=template&id=1ac90b7b&", function () {
      api.rerender('1ac90b7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductsDataDeviceV3.vue"
export default component.exports